import { Injectable, inject } from '@angular/core';
import { SessionStorageService } from '@core/session-storage.service';
import { ODataSession } from '../abstractions/odata-session';
import { FilterQueryBuilder } from '../models/filter-query-builder';
import { PlainObject } from 'odata-query';
import { SessionTimeoutService } from '@core/session-timeout.service';
import { AuthService } from '@core/services/auth.service';
import { FilterSessionManagerService } from './filter-session-manager.service';

@Injectable()
export class FilterSessionService {
  private readonly session = inject(SessionStorageService);
  private readonly filterSessionManager = inject(FilterSessionManagerService);
  private readonly sessionTimeout = inject(SessionTimeoutService);
  private readonly auth = inject(AuthService);

  hasStoredSession = false;
  private queryBuilder: FilterQueryBuilder | undefined;

  constructor() {
    this.sessionTimeout.closeSession$.subscribe(() => {
      this.destroySession();
    });

    this.auth.logout$.subscribe(() => {
      this.destroySession();
    });
  }

  defineSession(sessionKey: string): void {
    let session: ODataSession = {};
    if (this.session.has(sessionKey)) {
      session = this.session.getModel<ODataSession>(sessionKey);
      this.hasStoredSession = true;
    }
    this.queryBuilder = new FilterQueryBuilder(session);
    this.filterSessionManager.initialize(this.queryBuilder, sessionKey);
  }

  get hasSession(): boolean {
    return this.queryBuilder !== undefined;
  }

  getSession(): FilterQueryBuilder {
    return this.queryBuilder!;
  }

  getQuery(): PlainObject {
    let query: PlainObject = {};
    if (this.queryBuilder) {
      query = this.queryBuilder!.toQuery();
    }
    return query;
  }

  getSessionValue<T>(key: string): T {
    return this.queryBuilder!.getValue(key)! as T;
  }

  destroySession(): void {
    this.queryBuilder = undefined;
    this.filterSessionManager.destroy();
  }
}
